interface SvgMinusProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgMinus(props: SvgMinusProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M18 11.25H6V12.75H18V11.25Z" fill="currentColor" /></svg>;
}